document.addEventListener('DOMContentLoaded', function () {
  var wishlistWrapper = document.querySelector('.product-checklist-status');
  var wishlistError = document.querySelector('.error-wishlist');
  var wishlistButton = document.getElementById('wishlist-button');
  var needitButton = document.getElementById('needit-button');
  var haveitButton = document.getElementById('haveit-button');
  var wishlistedWrapper = document.getElementById('wishlistedVariants');
  var variantSelect = document.querySelector('select[name="options[Edition Type]"]');

  var wishlistedJSON, sku, action, tofilter, typeList;

  if (typeof wishlistedWrapper !== 'undefined' && wishlistedWrapper !== null) {
    wishlistedJSON = JSON.parse(wishlistedWrapper.innerText);
  }

  function postWishlist(customerId, sku, action, checklist, typeList) {
    return fetch('https://app.vinegarsyndrome.com/wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'owner_id=' + customerId + '&sku=' + sku + '&action=' + action + '&checklist=' + checklist + '&typeList=' + typeList
    });
  }

  if (typeof needitButton !== 'undefined' && needitButton != null) {
    typeList = needitButton.dataset.type === 'vinegar' ? 'vinegar' : 'partner';

    needitButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (haveitButton.classList.contains('checked')) return false;

      sku = needitButton.dataset.sku;
      wishlistWrapper.classList.add('processing');
      wishlistError.innerText = '';
      action = needitButton.classList.contains('checked') ? 'unchecked' : 'checked';

      postWishlist(needitButton.dataset.customerId, sku, action, 'need', typeList)
        .then(function (response) {
          if (action === 'checked') {
            needitButton.classList.add('checked');
            wishlistedJSON.wishlisted.push(needitButton.dataset.sku);
          } else {
            needitButton.classList.remove('checked');
            wishlistedJSON.wishlisted = wishlistedJSON.wishlisted.filter(function (wsku) {
              return wsku !== needitButton.dataset.sku;
            });
          }
          wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
          wishlistWrapper.classList.remove('processing');
        })
        .catch(function (error) {
          console.error(error);
          wishlistWrapper.classList.remove('processing');
          wishlistError.innerText = 'There was an error, please try again!';
        });
    });
  }

  if (typeof haveitButton !== 'undefined' && haveitButton != null) {
    typeList = haveitButton.dataset.type === 'vinegar' ? 'vinegar' : 'partner';

    haveitButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (needitButton.classList.contains('checked')) needitButton.classList.remove('checked');

      sku = haveitButton.dataset.sku;
      wishlistWrapper.classList.add('processing');
      wishlistError.innerText = '';
      action = haveitButton.classList.contains('checked') ? 'unchecked' : 'checked';

      postWishlist(haveitButton.dataset.customerId, sku, action, 'have', typeList)
        .then(function (response) {
          if (action === 'checked') {
            haveitButton.classList.add('checked');
            wishlistedJSON.have.push(haveitButton.dataset.sku);
          } else {
            haveitButton.classList.remove('checked');
            wishlistedJSON.have = wishlistedJSON.have.filter(function (wsku) {
              return wsku !== haveitButton.dataset.sku;
            });
          }
          wishlistedWrapper.innerText = JSON.stringify(wishlistedJSON);
          wishlistWrapper.classList.remove('processing');
        })
        .catch(function (error) {
          console.error(error);
          wishlistWrapper.classList.remove('processing');
          wishlistError.innerText = 'There was an error, please try again!';
        });
    });
  }

  if (typeof variantSelect !== 'undefined' && variantSelect != null &&
      typeof needitButton !== 'undefined' && needitButton != null) {
    variantSelect.addEventListener('change', function (e) {
      sku = document.querySelector('#variantSku').innerText;
      needitButton.dataset.sku = sku;
      haveitButton.dataset.sku = sku;

      if (wishlistedJSON.wishlisted.length !== 0) {
        for (var i = 0; i < wishlistedJSON.wishlisted.length; i++) {
          var w = wishlistedJSON.wishlisted[i];
          if (w == sku) {
            needitButton.classList.add('checked');
            break;
          } else if (needitButton.classList.contains('checked')) {
            needitButton.classList.remove('checked');
          }
        }
      }

      if (wishlistedJSON.have.length !== 0) {
        for (var i = 0; i < wishlistedJSON.have.length; i++) {
          var w = wishlistedJSON.have[i];
          if (w == sku) {
            haveitButton.classList.add('checked');
            break;
          } else if (haveitButton.classList.contains('checked')) {
            haveitButton.classList.remove('checked');
          }
        }
      }
    });
  }
});

/* voltage: flex-carousel autoplay accessibility
   Stops for reduced motion and pauses on keyboard focus (Swiper's pauseOnMouseEnter is hover only). */
(function () {
  function enhance(el) {
    var swiper = el.swiperInstance;
    if (!swiper || !swiper.autoplay || !swiper.params || !swiper.params.autoplay) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var applyMotionPreference = function () {
      if (reduce.matches) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
    };
    applyMotionPreference();
    if (reduce.addEventListener) reduce.addEventListener('change', applyMotionPreference);

    el.addEventListener('focusin', function () {
      if (!reduce.matches) swiper.autoplay.pause();
    });
    el.addEventListener('focusout', function (event) {
      if (reduce.matches) return;
      if (!el.contains(event.relatedTarget)) swiper.autoplay.resume();
    });
  }

  function init() {
    document.querySelectorAll('flex-carousel').forEach(function (el) {
      var tries = 0;
      (function waitForSwiper() {
        if (el.swiperInstance) return enhance(el);
        if (tries++ > 40) return; // ~4s
        setTimeout(waitForSwiper, 100);
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* voltage: ad tile video reduced motion */
(function () {
  function applyMotionPreference() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.ad-tile-voltage__video').forEach(function (video) {
      if (reduce) {
        video.autoplay = false;
        video.removeAttribute('loop');
        if (!video.paused) video.pause();
      } else if (video.paused) {
        video.play().catch(function () {});
      }
    });
  }

  function init() {
    applyMotionPreference();
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.addEventListener) mq.addEventListener('change', applyMotionPreference);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* voltage: ad tile video reduced motion */
(function () {
  function applyMotionPreference() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.ad-tile-voltage__video').forEach(function (video) {
      if (reduce) {
        video.autoplay = false;
        video.removeAttribute('loop');
        if (!video.paused) video.pause();
      } else if (video.paused) {
        video.play().catch(function () {});
      }
    });
  }

  function init() {
    applyMotionPreference();
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.addEventListener) mq.addEventListener('change', applyMotionPreference);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// voltage #33: hyphen lines as sub-bullets
// Rich-text metafield lines starting with "- " become nested bullets in accordions.
// Handles a whole <li>, <br>-separated lines inside an <li>, and loose <p> lines.
(function () {
  var HY = /^\s*-\s+/;
  function textOf(html) { return html.replace(/<[^>]*>/g, ''); }
  function stripHyphen(html) {
    return html.replace(/^(\s*(?:<[^>]+>)*\s*)-\s+/, '$1');
  }
  function subUl(items) {
    return '<ul class="vs-subbullets-voltage">' + items.map(function (s) {
      return '<li>' + stripHyphen(s) + '</li>';
    }).join('') + '</ul>';
  }
  // Group consecutive hyphen lines in <br>-separated content into nested lists. Returns true if changed.
  function rebuildBrSegments(el) {
    var segments = el.innerHTML.split(/<br\s*\/?\s*>/i);
    if (segments.length < 2) return false;
    if (!segments.some(function (s) { return HY.test(textOf(s)); })) return false;
    var out = '';
    var textRun = [];
    var ulRun = [];
    function flushText() { if (textRun.length) { out += textRun.join('<br>'); textRun = []; } }
    function flushUl() { if (ulRun.length) { out += subUl(ulRun); ulRun = []; } }
    segments.forEach(function (seg) {
      if (HY.test(textOf(seg))) { flushText(); ulRun.push(seg); }
      else if (seg.trim() !== '') { flushUl(); textRun.push(seg); }
    });
    flushText(); flushUl();
    el.innerHTML = out;
    return true;
  }
  function applySubBullets(scope) {
    scope.querySelectorAll('.accordion__content li').forEach(function (li) {
      if (li.classList.contains('vs-subbullet-voltage') || li.dataset.vsSubDone) return;
      if (rebuildBrSegments(li)) { li.dataset.vsSubDone = '1'; return; }
      if (!HY.test(li.textContent)) return;
      var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() !== '') {
          node.nodeValue = node.nodeValue.replace(HY, '');
          break;
        }
      }
      li.classList.add('vs-subbullet-voltage');
    });
    scope.querySelectorAll('.accordion__content p').forEach(function (p) {
      if (p.dataset.vsSubDone) return;
      var segments = p.innerHTML.split(/<br\s*\/?\s*>/i);
      if (!segments.some(function (s) { return HY.test(textOf(s)); })) return;
      p.dataset.vsSubDone = '1';
      if (segments.length > 1) { rebuildBrSegments(p); return; }
      // single-line "- " paragraph: swap the <p> for a one-item sub-list
      var ul = document.createElement('div');
      ul.innerHTML = subUl([p.innerHTML]);
      p.replaceWith(ul.firstChild);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applySubBullets(document); });
  } else {
    applySubBullets(document);
  }
})();

// voltage #27: random search recommendations
// Liquid renders a 2x pool; keep a random subset before the drawer opens so the carousel never reflows.
(function () {
  function pickRandomRecs() {
    var wrap = document.querySelector('.search__recommendation--products[data-vs-random-pick]');
    if (!wrap) return;
    var keep = parseInt(wrap.getAttribute('data-vs-random-pick'), 10) || 8;
    var wrapper = wrap.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var slides = Array.prototype.slice.call(wrapper.children);
    // small pools still get shuffled so the first row varies
    if (slides.length < 2) return;
    for (var i = slides.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = slides[i]; slides[i] = slides[j]; slides[j] = t;
    }
    slides.forEach(function (slide, idx) {
      if (idx < keep) { wrapper.appendChild(slide); } else { slide.remove(); }
    });
    var swiperEl = wrap.querySelector('.swiper');
    if (swiperEl && swiperEl.swiper) swiperEl.swiper.update();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pickRandomRecs);
  } else {
    pickRandomRecs();
  }
})();

// voltage #32: omit redaction in accordions
// Accordion metafields can't take Liquid filters, so [omit] is redacted here.
(function () {
  function redactOmits() {
    document.querySelectorAll('.accordion__content').forEach(function (el) {
      if (el.innerHTML.indexOf('[omit]') === -1) return;
      el.innerHTML = el.innerHTML.replace(
        /\[omit\][\s\S]*?\[\/omit\]/g,
        '<span class="vs-omit-voltage vs-omit-voltage--bar"><span class="visually-hidden">[omitted]</span></span>'
      ).replace(/\[omit\]|\[\/omit\]/g, '');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redactOmits);
  } else {
    redactOmits();
  }
})();

// voltage #4 / #73: publish sub nav height
// Exposes --vs-subnav-h so the sticky header pins below it. Runs in <head>, so waits for the DOM.
(function () {
  var init = function () {
    var section = document.querySelector('.voltage-subnav-shopify-section');
    if (!section) return;
    var publish = function () {
      document.documentElement.style.setProperty('--vs-subnav-h', Math.round(section.offsetHeight) + 'px');
    };
    publish();
    if (window.ResizeObserver) new ResizeObserver(publish).observe(section);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// voltage #64: instant variant label and inventory
// Pebble only refreshes these after a slow section re-render; update them on the click instead.
// variant:changed fires for every picker on the page, so both handlers stay scoped.
(function () {
  // option label: read the control that changed
  document.addEventListener('change', function (e) {
    var el = e.target;
    var option = el && el.closest ? el.closest('.variant-option') : null;
    if (!option) return;
    var label = option.querySelector('.variant-option__label-value');
    if (!label) return;
    var value = el.tagName === 'SELECT' ? (el.options[el.selectedIndex] || {}).text : el.value;
    if (value != null) label.textContent = String(value).trim();
  });

  // inventory line: same branches as blocks/_product-inventory-voltage.liquid
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || v.id == null) return;
    var id = String(v.id);
    document.querySelectorAll('product-inventory[data-vs-inventory]').forEach(function (inv) {
      // Public variant JSON has no inventory_quantity/policy, so read the Liquid map.
      // Its keys are this product's variant ids, which also filters out other pickers.
      if (!inv._vsInv) { try { inv._vsInv = JSON.parse(inv.dataset.vsInventory); } catch (err) { inv._vsInv = {}; } }
      var rec = inv._vsInv[id];
      if (!rec) return; // another product's picker
      var d = inv.dataset;
      var qty = Number(rec.q || 0);
      var status, type, text;
      if (rec.m === 'shopify') {
        if (qty > 0) {
          if (qty <= Number(d.vsThreshold || 0)) {
            status = 'low'; type = 'error';
            text = d.vsShowQty === 'true'
              ? (qty === 1 ? d.vsTextLowOne : d.vsTextLowOther.replace('999999', String(qty)))
              : d.vsTextLow;
          } else { status = 'in_stock'; type = 'success'; text = d.vsTextIn; }
        } else if (rec.p === 'continue') { status = 'in_stock'; type = 'success'; text = d.vsTextIn; }
        else { status = 'out_of_stock'; type = 'out-of-stock'; text = d.vsTextOut; }
      } else { status = 'in_stock'; type = 'success'; text = d.vsTextIn; }

      var statusEl = inv.querySelector('.product-inventory__status');
      var iconEl = inv.querySelector('.product-inventory__icon');
      var textEl = inv.querySelector('.product-inventory__text');
      if (statusEl) statusEl.className = 'product-inventory__status notification--' + type;
      if (iconEl) {
        iconEl.className = 'inline-flex icon product-inventory__icon product-inventory__icon-' + status;
        var tpl = inv.querySelector('template[data-vs-icon="' + status + '"]');
        if (tpl) { iconEl.innerHTML = ''; iconEl.appendChild(tpl.content.cloneNode(true)); }
      }
      if (textEl) textEl.textContent = text;
    });
  });
})();

// voltage #99: sticky add-to-cart gate
// Bar stays hidden until the reviews section is reached.
(function () {
  function init() {
    document.querySelectorAll('sticky-add-to-cart[data-vs-sticky-gate]').forEach(function (host) {
      var target = document.querySelector('.shopify-section[id*="okendo_reviews_widget"]');
      if (!target || !('IntersectionObserver' in window)) return;
      host.classList.add('vs-sticky-gated');
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        // reached once the reviews section top enters the viewport or is already above it
        var reached = entry.isIntersecting || entry.boundingClientRect.top < 0;
        host.classList.toggle('vs-sticky-gated', !reached);
      }).observe(target);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// voltage #117: external links open in a new tab
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!link || link.target) return;
    var url;
    try { url = new URL(link.href); } catch (e) { return; }
    if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return;
    link.target = '_blank';
    link.rel = link.rel ? link.rel + ' noopener' : 'noopener';
  });
})();

// voltage #120: a tap anywhere on a mobile menu row opens it
// the theme sends a row tap to the row's url, '#' included; only the arrow opens it
(function () {
  window.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var summary = target.closest('details[is="menu-drawer-details"][level="top"] > summary, menu-drawer-submenu summary');
    if (!summary) return;
    var arrow = summary.querySelector('.menu-drawer__item-link-arrow');
    if (!arrow || arrow.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    arrow.click();
  }, true);
})();

// voltage #147: mobile menu, a group's images start loading on first touch of its row
(function () {
  window.addEventListener('pointerdown', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var summary = target.closest('menu-drawer-submenu summary');
    if (!summary || !summary.parentElement) return;
    var imgs = summary.parentElement.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
  }, { passive: true });
})();

// voltage #124: collapse or expand every accordion row, remembered across products
(function () {
  var KEY = 'vs-accordion-collapsed';
  function setAll(accordion, open) {
    // single-open would close each row as the next one opens
    if (open && accordion.dataset.singleOpen === 'true') {
      accordion.dataset.voltageSingle = 'true';
      delete accordion.dataset.singleOpen;
    } else if (!open && accordion.dataset.voltageSingle === 'true') {
      accordion.dataset.singleOpen = 'true';
    }
    accordion.toggleAttribute('data-voltage-expanded', open);
    accordion.querySelectorAll('details.accordion__details').forEach(function (item) {
      if (item.open === open || typeof accordion.toggleOpen !== 'function') return;
      accordion.toggleOpen({
        willOpen: open,
        item: item,
        summary: item.querySelector('summary'),
        content: item.querySelector('.accordion__content')
      });
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-accordion-collapse-all]');
    if (!button) return;
    var open = !button.closest('accordion-component').hasAttribute('data-voltage-expanded');
    try { localStorage.setItem(KEY, open ? '0' : '1'); } catch (e) {}
    document.querySelectorAll('[data-accordion-collapse-all]').forEach(function (b) {
      var accordion = b.closest('accordion-component');
      b.textContent = open ? b.dataset.labelCollapse : b.dataset.labelExpand;
      if (accordion) setAll(accordion, open);
    });
  });
  // a single row opened or closed by hand: the button says what it will do next
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item.matches || !item.matches('details.accordion__details')) return;
    var accordion = item.closest('accordion-component');
    var button = accordion && accordion.querySelector('[data-accordion-collapse-all]');
    if (!button) return;
    var allOpen = [].every.call(accordion.querySelectorAll('details.accordion__details'), function (d) { return d.open; });
    accordion.toggleAttribute('data-voltage-expanded', allOpen);
    button.textContent = allOpen ? button.dataset.labelCollapse : button.dataset.labelExpand;
  }, true);
})();

// voltage #132: popular searches stop at two rows, whatever the screen width
(function () {
  function clamp(list) {
    var items = list.children;
    var rows = [];
    for (var i = 0; i < items.length; i++) items[i].hidden = false;
    for (var k = 0; k < items.length; k++) {
      var top = items[k].offsetTop;
      if (rows.indexOf(top) === -1) rows.push(top);
      if (rows.length > 2) items[k].hidden = true;
    }
  }
  function init() {
    if (!('ResizeObserver' in window)) return;
    document.querySelectorAll('.search__recommendation--keywords .search__list--btn').forEach(function (list) {
      var width = 0;
      // the panel is hidden until search opens, so measure when it gets a width
      new ResizeObserver(function (entries) {
        var w = Math.round(entries[0].contentRect.width);
        if (!w || w === width) return;
        width = w;
        clamp(list);
      }).observe(list);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// voltage #148: trailer poster swaps in the youtube player on click
(function () {
  document.addEventListener('click', function (event) {
    var poster = event.target.closest && event.target.closest('[data-yt-facade-voltage]');
    if (!poster) return;
    var id = encodeURIComponent(poster.dataset.videoId);
    var query = poster.dataset.videoQuery;
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?' + (query ? query + '&' : '') + 'autoplay=1&playsinline=1&rel=0';
    iframe.title = poster.dataset.videoTitle || 'Video';
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.className = 'yt-gallery-voltage__iframe yt-gallery-voltage__frame--inline';
    poster.replaceWith(iframe);
    iframe.focus();
  });
})();
